
export interface InitSession200Response {
  message?: string;
  sessionId?: string;
  success?: boolean;
  userId?: string;
}
